module.exports = __webpack_public_path__ + "static/img/16gongjiaochuxing.b4cd45fc.gif";